import styled, { keyframes } from "styled-components";

export const SelectButton = styled.button<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  position: relative;
  width: fit-content;
  background: none;
  border: ${({ color }) => `1px solid ${color}`};
  color: ${({ color }) => color};
  font-size: 1rem;
  font-weight: 400;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  width: 100%;
`;

const ShowAnimation = keyframes`
  0% {
    transform: translateY(90%);
    opacity: 0;
  }

  100% {
    transform: translateY(105%);
    opacity: 1;
  }
`;

export const OptionsContainer = styled.div<{ show: boolean }>`
  position: absolute;
  bottom: 0;
  transform: translateY(105%);
  display: ${({ show }) => (show ? "flex" : "none")};
  background-color: white;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0.25rem;
  animation: ${ShowAnimation} 0.2s ease-in-out;
  z-index: 1;
  width: 100%;
  left: 0;
`;

export const OptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0;
  width: 100%;
`;

export const OptionItem = styled.li`
  padding: 0.25rem 0.75rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
  color: #222;
  white-space: nowrap;
  width: 100%;

  &:hover {
    background-color: #ddd;
  }
`;

export const Label = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
`;
